module.exports = __webpack_public_path__ + "static/media/WI.d35c8685.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/WI.svg
// module id = 253
// module chunks = 0